import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MerchantRegistrationComponent } from './merchant-registration/merchant-registration.component';

const routes: Routes = [
  { path: 'registration', component: MerchantRegistrationComponent, data: { title: 'Merchant Registration' } },
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
  { path: '**', redirectTo: 'not-found' },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
